<!-- 新建/编辑房源管理 -->
<template>
  <el-main>
    <div class="homePage">
      <div class="tableList">
        <div class="tableContent" :style="{padding:'10px 15px'}">
          <div class="cropper-app">
            <div><span>基本信息</span><el-divider></el-divider></div>
            <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate"  label-width="120px">
              <el-form-item label="标题:" prop="title">
                <el-input v-model="formValidate.title" placeholder="请输入标题"></el-input>
              </el-form-item>
              <el-row :style="{margin:'0px!important'}">
                <el-col :span="6" :style="{paddingLeft:'0px!important'}">
                  <el-form-item label="城市:" prop="city">
                    <el-select v-model="formValidate.city" placeholder="请选择城市" :style="{width:'100%'}" @change="getHouseApplyNo($event)">
                      <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="房源编号:" prop="no">
                    <el-input v-model="formValidate.no" placeholder="" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="formValidate.mode =='学生公寓'">
                  <el-form-item label="公寓官网链接:" prop="link">
                    <el-input v-model="formValidate.link" placeholder="请输入公寓官网链接"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" :style="{paddingRight:'0px!important'}">
                  <el-form-item label="公寓位置:" prop="position" v-if="formValidate.mode =='学生公寓'">
                    <el-input v-model="formValidate.position" placeholder="请输入公寓位置" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" :style="{paddingLeft:formValidate.mode =='学生公寓'?'0px!important':'10px!important'}">
                  <el-form-item label="建成时间:" prop="constructionTime">
                    <el-input v-model="formValidate.constructionTime" placeholder="请输入建成时间"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" :style="{paddingRight:formValidate.mode =='学生公寓'?'10px!important':'0!important'}">
                  <el-form-item label="楼层数:" prop="floor">
                    <el-input v-if="formValidate.mode =='学生公寓'" type="number" v-model="formValidate.floor" placeholder="请输入楼层数"></el-input>
                    <el-select v-else v-model="formValidate.floor" placeholder="请选择楼层数" :style="{width:'100%'}">
                      <el-option v-for="item in floorList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="价格:" prop="price" v-if="formValidate.mode !='学生公寓'">
                <el-tag :key="tag" v-for="tag in formValidate.priceList" closable :disable-transitions="false" @close="tagClose(tag,'price')">{{tag}}</el-tag>
                <span v-if="formValidate.priceVisible">
                <el-input class="input-new-tag" v-model="formValidate.priceValue" size="small"></el-input>
                <span>/周(租期 <el-input class="input-new-tag" v-model="formValidate.priceLeaseValue" ref="priceTagInput" size="small"></el-input> 周)</span>
                <el-button type="text" @click="handleInputConfirm('price')">保存</el-button>
              </span>
                <el-button v-else class="button-new-tag" size="small" @click="showInput('price')">+</el-button>
              </el-form-item>
              <el-form-item label="价格:" prop="price" v-if="formValidate.mode =='学生公寓' && this.$route.query.data != undefined">
                <el-tag :key="tag" v-for="tag in formValidate.priceList" :disable-transitions="false" @close="tagClose(tag,'price')">{{tag}}</el-tag>
                <span v-if="formValidate.priceVisible">
                  <el-input class="input-new-tag" v-model="formValidate.priceValue" size="small"></el-input>
                  <span>/周(租期 <el-input class="input-new-tag" v-model="formValidate.priceLeaseValue" ref="priceTagInput" size="small"></el-input> 周)</span>
                  <el-button type="text" @click="handleInputConfirm('price')">保存</el-button>
                </span>
              </el-form-item>
              <el-form-item label="学校:" v-if="this.$route.query.data != undefined">
                <el-tag :key="tag.id" v-for="tag in formValidate.schoolKeyword" closable :disable-transitions="false" @close="tagClose(tag,'school')">{{ tag.schoolName }}
                  <i :style="{marginLeft:'5px',cursor:'pointer'}" class="el-icon-edit" @click="editSchool(tag)"></i></el-tag>
                <el-popover placement="bottom" width="700" trigger="manual"  v-model="formValidate.schoolVisible">
                  <div class="cropper-app platform" :style="{padding:'15px 20px 0 20px'}">
                    <el-form :model="schoolForm" :rules="schoolRules" ref="schoolForm" label-width="120px">
                      <el-form-item label="学校:" prop="schoolValue">
                        <el-select v-model="schoolForm.schoolValue" placeholder="请选择学校" :style="{width:'100%'}">
                          <el-option v-for="item in schoolList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="到学校距离:" prop="schoolDistance" style="flex:1">
                          <el-input v-model="schoolForm.schoolDistance" placeholder="请输入到学校距离" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">公里</div>
                      </div>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="步行到校:" prop="schoolWalkTime" style="flex:1">
                          <el-input v-model="schoolForm.schoolWalkTime" placeholder="请输入步行到校时间" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">分钟</div>
                      </div>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="电车到校:" prop="schoolTramTime" style="flex:1">
                          <el-input v-model="schoolForm.schoolTramTime" placeholder="请输入电车到校时间" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">分钟</div>
                      </div>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="公交到校:" prop="schoolTransitTime" style="flex:1">
                          <el-input v-model="schoolForm.schoolTransitTime" placeholder="请输入公交到校时间" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">分钟</div>
                      </div>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="火车到校:" prop="schoolTrainTime"  style="flex:1">
                          <el-input v-model="schoolForm.schoolTrainTime" placeholder="请输入火车到校时间" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">分钟</div>
                      </div>
                      <el-form-item :style="{textAlign:'center',marginRight:'110px'}">
                        <el-button type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, padding: '10px 20px',width:'70px'}" @click="waySubmit('schoolForm')">保存</el-button>
                        <el-button @click="formValidate.schoolVisible = false" :style="{padding: '10px 20px', width:'70px'}">取消</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-button slot="reference" @click="openSchool" class="button-new-tag" size="small">+</el-button>
                </el-popover>
              </el-form-item>
              <el-form-item label="公共交通:" v-if="this.$route.query.data != undefined">
                <el-tag :key="tag.id" v-for="tag in formValidate.trafficKeyword" closable :disable-transitions="false" @close="tagClose(tag.id,'traffic')">{{ tag.name }}
                  <i :style="{marginLeft:'5px',cursor:'pointer'}" class="el-icon-edit" @click="editTraffic(tag)"></i></el-tag>
                <el-popover placement="bottom" width="700" trigger="manual"  v-model="formValidate.trafficVisible">
                  <div class="cropper-app platform" :style="{padding:'15px 20px 0 20px'}">
                    <el-form :model="trafficForm" :rules="trafficRules" ref="trafficForm" label-width="120px">
                      <el-form-item label="交通方式:" prop="trafficMode">
                        <el-select v-model="trafficForm.trafficMode" placeholder="请选择交通方式" :style="{width:'100%'}">
                          <el-option v-for="item in trafficModeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="站名:" prop="stationName">
                        <el-input v-model="trafficForm.stationName" placeholder="请输入站名" ></el-input>
                      </el-form-item>
                      <div style="display: flex; flex-direction: row;" >
                        <el-form-item label="到公共交通距离:" prop="trafficDistance" style="flex:1">
                          <el-input v-model="trafficForm.trafficDistance" placeholder="请输入到公共交通距离" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">公里</div>
                      </div>
                      <div style="display: flex; flex-direction: row;">
                        <el-form-item label="到公共交通时间:" prop="trafficTime"  style="flex:1">
                          <el-input v-model="trafficForm.trafficTime" placeholder="请输入到公共交通时间" ></el-input>
                        </el-form-item>
                        <div style="padding-left: 10px; padding-top: 10px;">分钟</div>
                      </div>
                      <el-form-item :style="{textAlign:'center',marginRight:'110px'}">
                        <el-button type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, padding: '10px 20px',width:'70px'}" @click="trafficSubmit('trafficForm')">保存</el-button>
                        <el-button @click="formValidate.trafficVisible = false" :style="{padding: '10px 20px', width:'70px'}">取消</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-button slot="reference" @click="openTraffic" class="button-new-tag" size="small">+</el-button>
                </el-popover>
              </el-form-item>
              <el-form-item label="区域:">
                <el-tag :key="tag" v-for="tag in formValidate.regionKeyword" closable :disable-transitions="false" @close="tagClose(tag,'region')">{{ tag }}</el-tag>
                <el-select v-if="formValidate.regionVisible" v-model="formValidate.regionValue" placeholder="请选择区域" ref="regionTagInput" size="small" @keyup.enter.native="handleInputConfirm('region')" @change="handleInputConfirm('region')">
                  <el-option v-for="item in regionList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
                <el-button v-else class="button-new-tag" size="small" @click="showInput('region')">+</el-button>
              </el-form-item>
              <el-form-item label="标签:" v-if="this.$route.query.data != undefined">
                <el-tag :key="tag.id" v-for="tag in formValidate.tagHouseKeyword" closable :disable-transitions="false" @close="tagClose(tag,'tagHouse')">{{ tag.tagName }}</el-tag>
                <el-select v-if="formValidate.tagHouseVisible" v-model="formValidate.tagHouseValue" placeholder="请选择标签" ref="tagHouseTagInput" size="small" @keyup.enter.native="handleInputConfirm('tagHouse')" @change="handleInputConfirm('tagHouse')">
                  <el-option v-for="item in tagHouseList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
                <el-button v-else class="button-new-tag" size="small" @click="showInput('tagHouse')">+</el-button>
              </el-form-item>
              <!--<el-form-item label="地标:">
                <el-tag :key="tag" v-for="tag in formValidate.landmarkKeyword" closable :disable-transitions="false" @close="tagClose(tag,'landmark')">{{ tag }}</el-tag>
                <el-select v-if="formValidate.landmarkVisible" v-model="formValidate.landmarkValue" placeholder="请选择地标" ref="landmarkTagInput" size="small" @keyup.enter.native="handleInputConfirm('landmark')" @change="handleInputConfirm('landmark')">
                  <el-option v-for="item in landmarkList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
                <el-button v-else class="button-new-tag" size="small" @click="showInput('landmark')">+</el-button>
              </el-form-item>-->
              <el-form-item label="房源优惠:" v-if="this.$route.query.data != undefined">
                <el-tag :key="tag.id" v-for="tag in formValidate.discountKeyword" v-if="tag.type == 1" closable :disable-transitions="false" @close="tagClose(tag,'discount')"
                        :style="{backgroundColor:tag.color.split(',')[0],borderColor:tag.color.split(',')[0],color:tag.color.split(',')[1]}">
                  <span>{{ tag.title }}</span>
                  <i :style="{marginLeft:'5px',cursor:'pointer'}" class="el-icon-edit" @click="editDiscount(tag,1)"></i></el-tag>
                <el-popover placement="bottom" width="700" trigger="manual"  v-model="formValidate.discountVisible">
                  <div class="cropper-app platform" :style="{padding:'15px 20px 0 20px'}">
                    <el-form :model="discountForm" :rules="discountRules1" ref="discountForm" label-width="110px">
                      <!-- <el-form-item label="标签类型:" prop="type">
                         <el-select v-model="discountForm.type" placeholder="请选择标签类型" :style="{width:'100%'}">
                           <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                         </el-select>
                       </el-form-item>-->
                      <el-form-item label="优惠政策标签:" prop="discountLabel">
                        <el-input v-model="discountForm.discountLabel" placeholder="请输入优惠政策标签" ></el-input>
                      </el-form-item>
                      <el-row :style="{ margin:'0 !important'}">
                        <el-col :span="9" :style="{ padding:'0 !important'}">
                          <el-form-item label="标签背景颜色:" prop="backgroundColor">
                            <el-color-picker v-model="discountForm.backgroundColor"></el-color-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="9" :style="{ padding:'0 !important'}">
                          <el-form-item label="标签字体颜色:" prop="wordColor">
                            <el-color-picker v-model="discountForm.wordColor"></el-color-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6" :style="{ padding:'0 !important'}">
                          <div :style="{display:'flex',flexDirection: 'row',paddingTop:'10px'}">
                            <div :style="{backgroundColor:discountForm.backgroundColor,color:discountForm.wordColor,borderRadius:'5px',padding:'2px 5px'}">{{ discountForm.discountLabel }}</div>
                          </div>
                        </el-col>
                      </el-row>
                      <el-form-item label="优惠政策内容:" prop="discountContent">
                        <el-input type="textarea" v-model="discountForm.discountContent" placeholder="请输入优惠政策内容" ></el-input>
                      </el-form-item>
                      <el-form-item label="优惠政策规则:" prop="discountRule">
                        <el-input type="textarea" v-model="discountForm.discountRule" placeholder="请输入优惠政策规则" ></el-input>
                      </el-form-item>
                      <el-form-item label="优惠开始时间:" prop="startTime">
                        <el-date-picker :style="{width:'100%'}" v-model="discountForm.startTime" :picker-options="pickerEffective" type="datetime" placeholder="请选择优惠开始时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="优惠结束时间:" prop="endTime">
                        <el-date-picker :style="{width:'100%'}" v-model="discountForm.endTime" :picker-options="pickerInvalid" type="datetime" placeholder="请选择优惠结束时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                      </el-form-item>
                      <el-form-item :style="{textAlign:'center',marginRight:'110px'}">
                        <el-button type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, padding: '10px 20px',width:'70px'}" @click="discountSubmit('discountForm')">保存</el-button>
                        <el-button @click="formValidate.discountVisible = false" :style="{padding: '10px 20px', width:'70px'}">取消</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-button slot="reference" @click="openDiscount(1)" class="button-new-tag" size="small">+</el-button>
                </el-popover>
              </el-form-item>
              <el-form-item label="退订政策:" v-if="this.$route.query.data != undefined">
                <el-tag :key="tag.id" v-for="tag in formValidate.discountKeyword" v-if="tag.type == 2" closable :disable-transitions="false" @close="tagClose(tag,'discount')"
                        :style="{backgroundColor:tag.color.split(',')[0],borderColor:tag.color.split(',')[0],color:tag.color.split(',')[1]}">
                  <span>{{ tag.title }}</span>
                  <i :style="{marginLeft:'5px',cursor:'pointer'}" class="el-icon-edit" @click="editDiscount(tag,2)"></i></el-tag>
                <el-popover placement="bottom" width="700" trigger="manual"  v-model="formValidate.discountOutVisible">
                  <div class="cropper-app platform" :style="{padding:'15px 20px 0 20px'}">
                    <el-form :model="discountForm" :rules="discountRules2" ref="discountForm" label-width="110px">
                      <!--<el-form-item label="标签类型:" prop="type">
                        <el-select v-model="discountForm.type" placeholder="请选择标签类型" :style="{width:'100%'}">
                          <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>-->
                      <el-form-item label="退订政策标题:" prop="discountLabel">
                        <el-input v-model="discountForm.discountLabel" placeholder="请输入退订政策标题" ></el-input>
                      </el-form-item>
                      <el-form-item label="退订政策内容:" prop="discountContent">
                        <el-input type="textarea" v-model="discountForm.discountContent" placeholder="请输入退订政策内容" ></el-input>
                      </el-form-item>
                      <el-form-item :style="{textAlign:'center',marginRight:'110px'}">
                        <el-button type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, padding: '10px 20px',width:'70px'}" @click="discountSubmit('discountForm')">保存</el-button>
                        <el-button @click="formValidate.discountOutVisible = false" :style="{padding: '10px 20px', width:'70px'}">取消</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-button slot="reference" @click="openDiscount(2)" class="button-new-tag" size="small">+</el-button>
                </el-popover>
              </el-form-item>
              <!--<el-form-item label="租期:">
                <el-input v-model="formValidate.tenancy" placeholder="请输入租期"></el-input>
              </el-form-item>-->
              <el-form-item label="描述:">
                <el-input type="textarea" v-model="formValidate.introduction" placeholder="请输入描述"></el-input>
              </el-form-item>
              <el-form-item label="特殊情况备注:">
                <el-input type="textarea" :rows="4" v-model="formValidate.remarks" maxlength="500" show-word-limit placeholder="请输入特殊情况备注"></el-input>
              </el-form-item>
              <el-form-item label="房源地图:">
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-if="formValidate.mapList!= ''">
                  <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(formValidate.mapList)">
                  <i @click="delMap" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                </li>
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}">
                  <el-upload
                    class="avatar-uploader-map"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :http-request="handleHttpRequestPhoto">
                    <img v-if="formValidate.mainMap" :src="formValidate.mainMap" class="avatar-map" :style="{width:'230px',height:'150px',marginLeft:'10px'}">
                    <div v-else class="avatar-uploader-map-child"><i class="el-icon-plus avatar-uploader-icon"></i><span style="font-size: 14px;">添加图片</span></div>
                  </el-upload>
                </li>
              </el-form-item>
              <!--<el-form-item label="房源地图:">
                <div class="list-img-box">
                  <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-if="formValidate.mapList!= ''">
                    <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(formValidate.mapList)">
                    <i @click="delMap" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                  </li>
                  <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}">
                    <div :style="{width:'230px',height: '150px',float:'left'}" class="upload-btn" @click="uploadPicture('flagMap')">
                      <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加图片</span>
                    </div>
                  </li>
                  <img v-show="false" :src="formValidate.mainMap" :style="{width:'230px',height:'150px',marginLeft:'10px'}"  alt="自定义图片">
                </div>
                <input type="hidden" v-model="formValidate.mainMap" placeholder="请添加图片">
              </el-form-item>-->
              <el-form-item label="照片:">
                <div class="list-img-box">
                  <draggable group="article" :value="formValidate.photoList" @input="handleListPictureChange($event)">
                    <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-for="(item,index) in formValidate.photoList" :key="index">
                      <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(item)">
                      <i @click="delPhoto(index)" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                    </li>
                  </draggable>
                  <img v-show="false" :src="formValidate.mainImage" :style="{width:'230px',height:'150px',marginLeft:'10px'}"  alt="自定义图片">
                  <div :style="{width:'230px',height: '150px'}" class="upload-btn" @click="uploadPicture('flagImg')">
                    <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加图片</span>
                  </div>
                </div>
                <input type="hidden" v-model="formValidate.mainImage" placeholder="请添加图片">
              </el-form-item>
              <el-form-item label="视频:">
                <div class="list-img-box">
                  <draggable group="article" :value="formValidate.videoList" @input="handleListVideoChange($event)">
                    <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-for="(item,index) in formValidate.videoList" :key="index">
                      <video :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(item)" controls="controls"></video>
                      <i @click="delVideo(index)" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                    </li>
                  </draggable>
                  <video v-show="false" :src="formValidate.mainVideo" :style="{width:'230px',height:'150px',marginLeft:'10px'}" controls="controls"></video>
                  <div :style="{width:'230px',height: '150px'}" class="upload-btn" @click="uploadVideo()">
                    <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加视频</span>
                  </div>
                </div>
                <input type="hidden" v-model="formValidate.mainVideo" placeholder="请添加视频">
              </el-form-item>
              <!-- 房屋信息 -->
              <div v-if="formValidate.mode !='学生公寓'"><span>房屋信息</span><el-divider></el-divider></div>
              <el-row v-if="formValidate.mode !='学生公寓'" :style="{margin:'0px!important'}">
                <el-col :span="6" :style="{paddingLeft:'0px!important'}">
                  <el-form-item label="户型面积:" prop="measure">
                    <el-input v-model="formValidate.measure" placeholder="请输入户型面积"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="卫浴:" prop="area">
                    <el-select v-model="formValidate.area" placeholder="请选择卫浴" :style="{width:'100%'}">
                      <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="家具:" prop="furniture">
                    <el-select v-model="formValidate.furniture" placeholder="请选择家具" :style="{width:'100%'}">
                      <el-option v-for="item in furnitureList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="厨房:" prop="parkingSpace" style="{paddingRight:'0px!important'}">
                    <el-select v-model="formValidate.parkingSpace" placeholder="请选择厨房" :style="{width:'100%'}">
                      <el-option v-for="item in areaparkingSpaceList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="formValidate.mode !='学生公寓'">
                  <el-form-item label="车位:" prop="parkingSpaceA">
                    <el-input v-model="formValidate.parkingSpaceA" placeholder="请输入车位"></el-input>
                  </el-form-item>
                </el-col>
                <div v-if="this.$route.query.data != undefined">
                  <div v-for="(item,index) in formValidate.mattressList" :key="index">
                    <el-col :span="6" style="position: relative">
                      <el-form-item label="床垫:" prop="info" >
                        <div>{{item.info}}</div>
                      </el-form-item>
                      <div style="position:absolute; top:9px;right:0px;color:rgb(234, 7, 34);cursor: pointer;" @click="delParkingInput(index)"><i class="el-icon-error"></i></div>
                    </el-col>
                  </div>
                </div>
                <div v-if="this.$route.query.data != undefined">
                  <div v-for="(item,index) in table.houseTableData" :key="index">
                    <el-col :span="6" style="position: relative">
                      <el-form-item :label="item.customName + ':'" prop="measure">
                        <div>{{item.content}}</div>
                      </el-form-item>
                      <div style="position:absolute; top:9px;right:0px;color:rgb(234, 7, 34);cursor: pointer;" @click="delHousingInput(index)"><i class="el-icon-error"></i></div>
                    </el-col>
                  </div>
                </div>
                <div v-if="this.$route.query.data != undefined">
                  <el-col :span="6" style="display: flex; flex-direction: row;">
                    <el-button style="margin-top: 4px;" class="button-new-tag" size="small" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="addParkingInput">新增床垫</el-button>
                    <el-button style="margin-top: 4px;" class="button-new-tag" size="small" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="addHousingInput">新增房屋信息</el-button>
                  </el-col>
                </div>
              </el-row>
              <div style="padding-top: 10px"><span>{{formValidate.mode !='学生公寓'?'房间设置':'公寓楼设施'}}</span><el-divider></el-divider></div>
              <div v-if="formValidate.mode !='学生公寓'">
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <!-- 拼接项目 -->
                  <template v-for="(item,index) in projectFList" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
              </div>
              <div v-else>
                <div style="padding: 0 0 10px 0">公寓楼设施 - 公共设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <template v-for="(item,index) in projectG_1List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 公寓服务</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <template v-for="(item,index) in projectG_2List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 室外设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <template v-for="(item,index) in projectG_3List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 安保设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <template v-for="(item,index) in projectG_4List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
              </div>
              <div v-if="formValidate.mode !='学生公寓'" :style="{marginTop: '15px'}"><span>公寓楼设施</span><el-divider></el-divider></div>
              <div v-if="formValidate.mode !='学生公寓'" >
                <div style="padding: 0 0 10px 0">公寓楼设施 - 公共设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <!-- 拼接项目 -->
                  <template v-for="(item,index) in projectG_1List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 公寓服务</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <!-- 拼接项目 -->
                  <template v-for="(item,index) in projectG_2List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 室外设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <!-- 拼接项目 -->
                  <template v-for="(item,index) in projectG_3List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
                <div style="padding: 10px 0">公寓楼设施 - 安保设施</div>
                <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
                  <!--列头 -->
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
                  <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
                  <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
                  <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
                  <!-- 拼接项目 -->
                  <template v-for="(item,index) in projectG_4List" :style="{border:'1px solid rgb(221, 221, 221)'}">
                    <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                    <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                    </el-col>
                    <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                      <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                    </el-col>
                    <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
                  </template>
                </el-row>
              </div>
              <!-- 剪裁图片组件弹窗 -->
              <el-dialog title="裁切图片" :visible.sync="cropperModel" width="2000px" center :close-on-click-modal="false" :before-close="handlePictureClose">
                <cropper-image :Name="cropperName" :cropperType="cropperType" @uploadImgSuccess="handleUploadPictureSuccess" ref="child" @handlePictureClose="handlePictureClose"></cropper-image>
              </el-dialog>
              <!--查看图片大封面-->
              <el-dialog title="查看大图片" :visible.sync="imgVisible" center>
                <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
              </el-dialog>
              <!-- 选择视频组件弹窗 -->
              <el-dialog title="选择视频" :visible.sync="videoModel" width="990px" center :close-on-click-modal="false" :before-close="handleVideoClose">
                <cropper-video @uploadVideoSuccess="handleUploadVideoSuccess" ref="video" @handleVideoClose="handleVideoClose"></cropper-video>
              </el-dialog>
              <!-- 保存 -->
              <div :style="{textAlign:'center',marginTop:'20px'}">
                <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
                <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
              </div>
              <!-- 费用明细 -->
              <div v-if="formValidate.mode =='学生公寓' && formValidate.isMode && this.$route.query.data != undefined":style="{marginBottom:'30px'}">
                <div><span>费用明细</span><el-divider></el-divider></div>
                <div class="search">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <div :style="{float:'right'}">
                      <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addCost">新建</el-button></el-form-item>
                      <el-form-item><el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delCost">删除</el-button></el-form-item>
                    </div>
                  </el-form>
                </div>
                <!-- 费用明细列表 -->
                <el-table
                  @selection-change="handleSelectionCostChange"
                  row-key="id"
                  class="table"
                  ref="costTableData"
                  :data="table.costTableData"
                  border
                  element-loading-text="拼命加载中,请等待"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.1)"
                >
                  <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
                  <el-table-column prop="costName" label="费用名称" align="center"></el-table-column>
                  <el-table-column prop="price" label="价格" align="center"></el-table-column>
                  <el-table-column prop="introduction" label="费用详情" align="center"></el-table-column>
                  <el-table-column label="操作" align="center" width="180" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="editCost('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor,marginLeft:'10px'}">编辑</el-button>
                      <el-popconfirm class="real_pop" title="您确定要删除房源信息吗？" @confirm="editCost('remove', scope.row)">
                        <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 显示户型 -->
              <div v-if="formValidate.mode =='学生公寓' && formValidate.isMode">
                <div><span>户型管理</span><el-divider></el-divider></div>
                <!-- <el-input class="input-new-tag" v-if="formValidate.apartmentClassifyVisible" v-model="formValidate.apartmentClassifyValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm('apartmentClassify')" @blur="handleInputConfirm('apartmentClassify')"></el-input>-->
                <el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addTab">添加户型</el-button>
                <el-drawer title="户型" :visible.sync="formValidate.apartmentClassifyVisible" direction="ttb" :show-close="false">
                  <div style="text-align: center; position: absolute; right: 20px; top:3px">
                    <el-button size="small" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="saveTab('formValidateHouse')">保存</el-button>
                    <el-button size="small"  @click="formValidate.apartmentClassifyVisible = false">取消</el-button>
                  </div>
                  <el-form :model="formValidateHouse" :rules="ruleHouseValidate" ref="formValidateHouse" label-width="120px">
                    <el-row style="margin-bottom: 0!important">
                      <el-col :span="12">
                        <el-form-item label="名称" prop="name">
                          <el-input type="textarea" v-model="formValidateHouse.name"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="简介" prop="introduction">
                          <el-input type="textarea" v-model="formValidateHouse.introduction"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <el-table
                    class="table"
                    :data="formValidate.apartmentClassifyList"
                    border
                    element-loading-text="拼命加载中,请等待"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.1)"
                  >
                    <el-table-column prop="name" label="名称" align="center"></el-table-column>
                    <el-table-column prop="introduction" label="简介" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" width="180" fixed="right">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="editTab('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor,marginLeft:'10px'}">编辑</el-button>
                        <el-popconfirm class="real_pop" title="您确定要删除户型信息吗？" @confirm="editTab('remove', scope.row)">
                          <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-drawer>
                <el-tabs v-model="formValidate.editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="handleClick" style="margin-top:10px">
                  <el-tab-pane v-for="(item, index) in formValidate.apartmentClassifyList" :key="item.id" :label="item.name" :name="item.name"></el-tab-pane>
                </el-tabs>
                <!-- 户型操作按钮及列表 -->
                <div class="search">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <div :style="{float:'right'}">
                      <el-form-item v-show="editSaveBtn"><el-button size="small" type="primary" icon="el-icon-edit" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="editSchoolAll">批量修改</el-button></el-form-item>
                      <el-form-item v-show="!editSaveBtn"><el-button size="small" type="primary" icon="el-icon-check" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="saveSchoolAll">保存</el-button></el-form-item>
                      <!--<el-form-item><el-button size="small" type="primary" icon="el-icon-edit" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="editSchoolAll">批量修改</el-button></el-form-item>-->
                      <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addSchool">新建</el-button></el-form-item>
                      <el-form-item><el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delSchool">删除</el-button></el-form-item>
                    </div>
                  </el-form>
                </div>
                <el-table
                  @selection-change="handleSelectionChange"
                  row-key="id"
                  class="table"
                  ref="tableData"
                  :key="tableData"
                  :data="table.tableData"
                  border
                  :height="table.tableHeight"
                  :span-method="arraySpanMethod"
                  element-loading-text="拼命加载中,请等待"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.1)">
                  >
                  <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
                  <el-table-column prop="no" label="房源编号" align="center"></el-table-column>
                  <el-table-column prop="soldout" label="不可预定" align="center">
                    <template slot-scope="scope">
                      <el-switch v-model="scope.row.soldout == 1 ? true:false" @change="changeHot($event,scope.row,'soldout')"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="grounding" label="上架" align="center">
                    <template slot-scope="scope">
                      <el-switch v-model="scope.row.grounding == 1 ? true:false" @change="changeHot($event,scope.row,'grounding')"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="标题" align="center"></el-table-column>
                  <el-table-column prop="term" label="租期" align="center">
                    <template slot-scope="scope">
                      <el-input size="small" v-model="scope.row.term" v-show="scope.row.showEdit" placeholder="请输入内容"></el-input>
                      <span v-show="!scope.row.showEdit">{{scope.row.term}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="start" label="起租日期" align="center">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.start" v-show="scope.row.showEdit"  type="date" placeholder="请选择起租日期"></el-date-picker>
                      <span v-show="!scope.row.showEdit">{{scope.row.start}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="finis" label="止租日期" align="center">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.finis" v-show="scope.row.showEdit"  type="date" placeholder="请选择止租日期"></el-date-picker>
                      <span v-show="!scope.row.showEdit">{{scope.row.finis}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="价格" align="center">
                    <template slot-scope="scope">
                      <el-input size="small" type="number" v-model="scope.row.price" v-show="scope.row.showEdit" placeholder="请输入内容" ></el-input>
                      <span v-show="!scope.row.showEdit">{{scope.row.price}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cz" label="操作" align="center" width="180" fixed="right">
                    <template slot-scope="scope">
                      <el-popconfirm class="real_pop" title="您确定要复制房源信息吗？" @confirm="handleOperation('copy', scope.row)">
                        <el-button slot="reference" type="text" size="mini" icon="el-icon-s-claim" :style="{color: $store.state.activeColor}">复制</el-button>
                      </el-popconfirm>
                      <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor,marginLeft:'10px'}">编辑</el-button>
                      <el-popconfirm class="real_pop" title="您确定要删除房源信息吗？" @confirm="handleOperation('remove', scope.row)">
                        <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 学生公寓新增/编辑 -->
    <el-dialog class="dialog" width="98%" :title="title" :visible.sync="outerVisible" v-if="outerVisible" :close-on-click-modal="false" top="1vh" :before-close="beforeClose" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-content" :style="{overflow: 'auto'}">
        <HousingManagementOperationSchool @closeDialog="closeDialog" ref="HousingManagementOperationSchool" :parentData="modeData" :dataList="childData" :isEdit="isEdit" :apartmentClassify="formValidate.editableTabsValue"></HousingManagementOperationSchool>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="appendContent">保存</el-button>
        <el-button  size="medium" :style="{width:'150px'}" @click="onCancelContent">取消</el-button>
      </div>
    </el-dialog>
    <!-- 房屋信息新增/编辑 -->
    <el-dialog class="dialog" width="98%" :title="houseTitle" :visible.sync="houseVisible" v-if="houseVisible" :close-on-click-modal="false" top="1vh" :before-close="beforeHouseClose" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-content" :style="{overflow: 'auto'}">
        <HousingMessageOperation @closeHousingDialog="closeHousingDialog" ref="HousingMessageOperation" :typeMess="typeMess" :addOrEdit="addOrEdit" :houseIdAOE="houseIdAOE" :childData="childData" :allList="allList" :tableDataChild="table.tableData"></HousingMessageOperation>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="appendHousingContent">保存</el-button>
        <el-button  size="medium" :style="{width:'150px'}" @click="onCancelHousingContent">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
  import CropperImage from "../Dialog/CropperImage";
  import CropperVideo from "../Dialog/CropperVideo";
  import { quillEditor } from "vue-quill-editor"; //调用编辑器
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import draggable from 'vuedraggable';
  import HousingManagementOperationSchool from './HousingManagementOperationSchool'
  import HousingMessageOperation from './HousingMessageOperation'
  export default {
    name: 'HousingManagementOperation',
    components: {
      CropperImage,
      CropperVideo,
      quillEditor,
      draggable,
      HousingManagementOperationSchool,
      HousingMessageOperation
    },
    data () {
      return {
        formInline:{},//查询参数
        formValidate: {
          title: '',//标题
          city: '',//城市
          no: '',//房源编号
          mode: '',//房型
          hot: 0,//是否热门
          modeList:['整租','短租','学生公寓'],//房型列表
          price: '',//价格
          priceList:[],//价格列表
          priceVisible: false,//价格标签输入框是否显示
          priceValue: '',//价格标签输入
          priceLeaseValue: '',//价格标签输入(括号内)
          schoolKeyword:[],//学校标签列表
          schoolVisible: false,//学校标签输入框是否显示
          schoolValue: '',//学校标签输入
          regionKeyword:[],//区域标签列表
          regionVisible: false,//区域标签输入框是否显示
          regionValue: '',//区域标签输入
          landmarkKeyword:[],//地标标签列表
          landmarkVisible: false,//地标标签输入框是否显示
          landmarkValue: '',//地标标签输入
          tagHouseKeyword:[],//标签列表
          tagHouseVisible: false,//标签输入框是否显示
          tagHouseValue: '',//标签输入
          discountKeyword:[],//房源优惠列表
          discountVisible:false,//房源优惠弹出框是否显示
          discountOutVisible:false,//退订政策弹出框是否显示
          trafficKeyword:[],//公共交通列表
          trafficVisible:false,//公共交通弹出框是否显示
          link: '',//公寓官网链接
          position: '',//公寓位置
          constructionTime: '',//建成时间
          tenancy: '',//租期
          introduction: '',//描述
          remarks: '',//特殊情况备注
          mainImage: '',//添加图片
          mainVideo: '',//添加video
          mainMap: '',//添加地图
          photoList: [],//添加图片列表
          videoList: [],//添加视频列表
          mapList: "",//添加视频列表
          mainImageSrc: '',//回显图片
          mainVideoSrc: '',//回显视频
          mainMapSrc: '',//回显地图
          area: '',//卫浴
          measure: '',//面积
          furniture: '',//家具
          floor: '',//楼层
          parkingSpace: '',//车位
          parkingSpaceA: '',//车位
          parking: '',//床垫
          mattressList:[],//床垫列表
          parentId:0,//房源父级
          projectList:[],//设施服务
          facilityServices:[],//设施服务
          facilityServicesTop:[],//设施服务推荐项
          apartmentClassifyList:[],//房型列表
          apartmentClassifyVisible: false, //输入框是否可用
          apartmentClassifyValue: '', // 输入框的值
          editableTabsValue:'0',//所选房型，默认选中第一个
          tabIndex: 0,//房型列表长度
          isMode:false, //不显示房型
          parentIdNew:'', // 新增父级Id
          facilities:'', // 自定义设施
          classification:1,//添加设施分类1.房间设施, 2.公寓楼设施
        },
        ruleValidate: { //图片非空验证
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          city: [
            { required: true, message: '请选择城市', trigger: 'change'}
          ],
          link: [
            { required: true, message: '请输入公寓官网链接', trigger: 'blur'}
          ],
          mode: [
            { required: true, message: '请选择房型', trigger: 'change'}
          ],
          mainImage: [
            { required: true, message: '请上传图片', trigger: 'blur'}
          ],
        },
        discountForm: { // 优惠政策
          id:"",// 优惠政策id
          type:1,// 标签类型
          discountLabel: "", // 优惠政策标签
          backgroundColor: "", // 标签背景颜色
          wordColor: "", // 标签字体颜色
          discountContent: "", // 优惠政策内容
          discountRule: "", // 优惠政策规则
          startTime: "",// 优惠政策开始时间
          endTime:"",// 优惠政策结束时间
        },
        discountRules1:{
          type:[
            { required: true, message: '请选择标签类别', trigger: 'change' },
          ],
          discountLabel:[
            { required: true, message: '请输入优惠政策标签', trigger: 'blur' },
          ],
          backgroundColor:[
            { required: true, message: '请选择标签背景颜色', trigger: 'change' },
          ],
          wordColor:[
            { required: true, message: '请选择标签字体颜色', trigger: 'change' },
          ]
        },
        discountRules2:{
          type:[
            { required: true, message: '请选择标签类别', trigger: 'change' },
          ],
          discountLabel:[
            { required: true, message: '请输入退订政策标题', trigger: 'blur' },
          ]
        },
        typeList:[{name:'优惠政策',id:1},{name:'退订政策',id:2}],//1.优惠政策 2.退订政策
        schoolForm: { // 学校
          id:"",// 公共交通id
          houseId:"",// 房源id
          schoolValue: "", // 学校
          schoolDistance: "", // 到校距离
          schoolWalkTime: "", // 步行到校时间
          schoolTramTime: "", // 电车到校时间
          schoolTransitTime: "", // 公交到校时间
          schoolTrainTime: "", // 火车到校时间
        },
        schoolRules:{
          schoolValue:[
            { required: true, message: '请选择学校', trigger: 'change' },
          ]
        },
        trafficForm: { // 公共交通
          id:"",// 公共交通id
          trafficMode: 1, // 交通方式
          houseId: "", // 房源id
          stationName: "", // 站名
          trafficDistance: "", // 到公共交通距离
          trafficTime: "", // 到公共交通时间
        },
        trafficRules:{
          trafficMode:[
            { required: true, message: '请选择交通方式', trigger: 'change' },
          ]
        },
        trafficModeList:[{label:'电车站',value:1},{label:'公交站',value:2},{label:'火车站',value:3}],//添加设施分类1.电车站, 2.公交站，3.火车站
        fangAdd:true, // 房型新增/编辑
        formValidateHouse: { // 户型分类
          id:"",// 户型分类id
          name: "", // 户型名称
          introduction: "", // 户型简介
        },
        ruleHouseValidate:{
          name:[
            { required: true, message: '请输入户型名称', trigger: 'blur' },
          ],
          introduction:[
            { required: true, message: '请输入简介', trigger: 'blur' },
          ]
        },
        pickerEffective:{
          disabledDate: time => {
            let endDateVal = this.discountForm.endTime;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            }
          }
        },
        pickerInvalid:{
          disabledDate: time => {
            let beginDateVal = this.discountForm.startTime;
            if (beginDateVal) {
              return (
                time.getTime() <
                new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
              )
            }
          }
        },
        cropperModel:false,// 裁切图片参数弹出框
        cropperName:"",// 裁切图片参数图片名称
        cropperType:2,// 裁切图片参数类型,2.照片3.地图
        imgName: "",// 裁切图片参数查看大图src
        imgVisible: false,// 裁切图片参数是否查看大图
        videoModel:false,// 选择视频弹出框
        tableData:false, // 表格数据是否更新
        editSaveBtn:true, // 表格数据是否更新
        table: { // 表格参数
          tableData:[], // 表格数据
          costTableData:[], // 费用明细数据
          houseTableData:[], //房屋信息数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: this.$store.state.size, // 条数
          total: 0, // 总数
        },
        checkIds:[], // 所选房源列表
        checkIdsCost:[], // 所选费用明细列表
        modeData:{}, // 父级数据
        childData:{}, // 子集数据
        allList:[],//传递数据
        isEdit:1, // 新增/编辑
        cityList:[], // 城市列表
        schoolList:[], // 学校列表
        regionList:[], // 区域列表
        landmarkList:[], // 地标列表
        discountList:[], // 房源优惠列表
        tagHouseList:[], // 房源标签列表
        areaList:[{id:1,name:"独立卫浴"},{id:2,name:"公共卫浴"}], // 卫浴
        areaNumberList:[{id:1,name:"1"},{id:2,name:"2"},{id:3,name:"3"}], // 卫浴
        areaparkingSpaceList:[{id:1,name:"独立厨房"},{id:2,name:"公共厨房"}], // 厨房
        furnitureList:[{id:1,name:"家具齐全"},{id:2,name:"无家具"}], // 家具数
        floorList:[{id:1,name:"低楼层"},{id:2,name:"中楼层"},{id:3,name:"高楼层"}], // 楼层
        outerVisible:false, // 户型的添加/编辑
        houseVisible:false, // 房屋的添加/编辑
        title:"", // 弹出框名称
        houseTitle:"", // 弹出框名称
        windowHeight:window.innerHeight, // 页面高度
        addOrEdit:1,//新增/编辑
        typeMess:1,//房屋信息
        houseIdAOE:0,//当前房源id
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
      projectFList: function() {
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 1
        })
      },
      projectG_1List: function() { //1.公共设施
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 2 && item.category == 1
        })
      },
      projectG_2List: function() { //2.公寓服务
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 2 && item.category == 2
        })
      },
      projectG_3List: function() { //3.室外设施
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 2 && item.category == 3
        })
      },
      projectG_4List: function() { //4.安保设施
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 2 && item.category == 4
        })
      }
    },
    methods: {
      // 图片上传
      async handleHttpRequestPhoto(data){
        let imageUrl = data.file;
        //调用axios上传
        let formData = new FormData();
        formData.append('file',imageUrl,'DX.jpg')
        await this.$api.fileUpload(formData).then(res => {
          if (res.data.status == 200) {
            this.formValidate.mainMapSrc = res.data.data[0].path;
            this.formValidate.mapImage = api_url+"/"+res.data.data[0].path;
            this.formValidate.mapList = this.formValidate.mainMapSrc;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 图片上传
      handleAvatarSuccess(res, file){
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG =  file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/gif"||
          file.type == "image/jpg";
        if (!isJPG) {
          this.$message.error('上传地图图片格式不正确!');
        }
        return isJPG;
      },
      // 保存
      appendContent(){
        this.$refs.HousingManagementOperationSchool.onConfirm();
      },
      // 取消
      onCancelContent(){
        this.$refs.HousingManagementOperationSchool.onCancel();
      },
      // 关闭弹框
      closeDialog(){
        this.outerVisible = false;
        this.getList();
      },
      // 关闭之前
      beforeClose(){
        this.$refs.HousingMessageOperation.clearContent();
      },
      // 保存
      appendHousingContent(){
        this.$refs.HousingMessageOperation.onConfirm();
      },
      // 取消
      onCancelHousingContent(){
        this.$refs.HousingMessageOperation.onCancel();
      },
      // 关闭弹框
      async closeHousingDialog(){
        this.houseVisible = false;
        if(this.typeMess == 1){
          this.table.houseTableData = await this.getHouseInfoNew(this.$route.query.data.id);
        } else if(this.typeMess == 2){
          this.getCost(this.$route.query.data.id);
        } else if(this.typeMess == 3){
          this.getList();
          this.tableData = !this.tableData;
          this.checkIds = [];
        } else if(this.typeMess == 4){
          //获取床垫信息
          this.formValidate.mattressList = await this.getMattressId(this.$route.query.data.id);
        }
      },
      // 关闭之前
      beforeHouseClose(){
        this.$refs.HousingMessageOperation.clearContent();
      },
      //图片设置
      uploadPicture(name){
        this.cropperName = name;
        if (name == "flagImg"){
          this.cropperType = 2;
        } else {
          this.cropperType = 3;
        }
        this.cropperModel = true;
      },
      //视频设置
      uploadVideo(){
        this.videoModel = true;
      },
      //图片上传成功后
      handleUploadPictureSuccess (data){
        if (this.cropperType == 2){
          this.formValidate.mainImageSrc = data[0].path;
          this.formValidate.mainImage = api_url+"/"+data[0].path;
          this.formValidate.photoList.push(this.formValidate.mainImageSrc);
          this.handlePictureClose();
        } else {
          this.formValidate.mainMapSrc = data[0].path;
          this.formValidate.mapImage = api_url+"/"+data[0].path;
          this.formValidate.mapList = this.formValidate.mainMapSrc;
          this.handlePictureClose();
        }
      },
      // 关闭上传图片弹出框
      handlePictureClose() {
        this.cropperModel = false;
        this.$refs.child.beClose();
      },
      //视频上传成功后
      handleUploadVideoSuccess (data){
        this.formValidate.mainVideoSrc = data[0].path;
        this.formValidate.mainVideo = api_url+"/"+data[0].path;
        this.formValidate.videoList.push(this.formValidate.mainVideoSrc);
        this.handleVideoClose();
      },
      // 关闭上传弹出框
      handleVideoClose() {
        this.videoModel = false;
        this.$refs.video.beClose();
      },
      // 转码
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g,'<');
        str = str.replace(/&gt;/g,'>');
        return str;
      },
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      // 删除房源地图
      delMap(){
        this.formValidate.mapList = "";
      },
      // 删除图片
      delPhoto(index){
        this.formValidate.photoList.splice(index,1);
      },
      // 删除视频
      delVideo(index){
        this.formValidate.videoList.splice(index,1);
      },
      // 删除学校/区域/地标/价格/房源优惠标签
      tagClose(tag,type) {
        if (type == 'school'){
          for(let i = 0 ; i < this.formValidate.schoolKeyword.length; i++){
            if (tag.id == this.formValidate.schoolKeyword[i].id){
              this.formValidate.schoolKeyword[i].status = 0;
            }
          }
          for (let i = 0; i < this.schoolList.length; i++){
            if (tag.schoolId == this.schoolList[i].id){
              this.schoolList[i].disabled = false;
            }
          }
          this.setBatchWay('删除成功！');
        } else if (type == 'region'){
          this.formValidate.regionKeyword.splice(this.formValidate.regionKeyword.indexOf(tag), 1);
          for (let i = 0; i < this.regionList.length; i++){
            if (this.regionList[i].name == tag){
              this.regionList[i].disabled = false;
            }
          }
        } else if (type == 'landmark'){
          this.formValidate.landmarkKeyword.splice(this.formValidate.landmarkKeyword.indexOf(tag), 1);
          for (let i = 0; i < this.landmarkList.length; i++){
            if (this.landmarkList[i].name == tag){
              this.landmarkList[i].disabled = false;
            }
          }
        } else if (type == 'price'){
          this.formValidate.priceList.splice(this.formValidate.priceList.indexOf(tag), 1);
        } else if (type == 'discount'){
          for(let i = 0 ; i < this.formValidate.discountKeyword.length; i++){
            if (tag.id == this.formValidate.discountKeyword[i].id){
              this.formValidate.discountKeyword[i].status = 0;
            }
          }
          this.$api.saveOrUpdatePreferentialBatch({ parameter: JSON.stringify(this.formValidate.discountKeyword)}).then(async res => {
            if (res.data.status == 200) {
              this.formValidate.discountKeyword = await this.getPreferentialsList(this.$route.query.data.id);//获取房源优惠标签
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        } else if (type == 'traffic'){
          for(let i = 0 ; i < this.formValidate.trafficKeyword.length; i++){
            if (tag == this.formValidate.trafficKeyword[i].id){
              this.formValidate.trafficKeyword[i].status = 0;
            }
          }
          this.setBatchTraffic('删除成功！');
        } else if(type == "tagHouse"){
          for(let i = 0 ; i < this.formValidate.tagHouseKeyword.length; i++){
            if (tag.id == this.formValidate.tagHouseKeyword[i].id){
              this.formValidate.tagHouseKeyword[i].status = 0;
            }
          }
          for (let i = 0; i < this.tagHouseList.length; i++){
            if (this.tagHouseList[i].name == tag){
              this.tagHouseList[i].disabled = false;
            }
          }
          this.saveTagHouse();
        }
      },
      // 批量添加修改到校方式列表
      setBatchWay(title){
        this.$api.saveOrUpdateWayBatch({ parameter: JSON.stringify(this.formValidate.schoolKeyword)}).then(async res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            //获取房源到校方式
            this.formValidate.schoolKeyword = await this.getWayList(this.$route.query.data.id);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 批量添加修改公共交通距离和时间列表
      setBatchTraffic(title){
        this.$api.saveOrUpdateTransitBatch({ parameter: JSON.stringify(this.formValidate.trafficKeyword)}).then(async res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            //获取房源公共交通距离和时间
            this.formValidate.trafficKeyword = await this.getHouseTransitList(this.$route.query.data.id);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 显示学校/区域/地标/价格/优惠标签
      showInput(type) {
        if(type == 'region'){
          this.formValidate.regionVisible = true;
        } else if(type == 'landmark'){
          this.formValidate.landmarkVisible = true;
        } else if(type == 'apartmentClassify'){
          this.formValidate.apartmentClassifyVisible = true;
        } else if(type == 'price'){
          this.formValidate.priceVisible = true;
        } else if(type == 'tagHouse'){
          this.formValidate.tagHouseVisible = true;
        }
      },
      // 添加学校/区域/地标/价格
      handleInputConfirm(type) {
        if (type == 'region'){
          let inputValue = this.formValidate.regionValue;
          if (inputValue) {
            this.formValidate.regionKeyword.push(inputValue);
          }
          for (let i = 0; i < this.regionList.length; i++){
            if (this.regionList[i].name == inputValue){
              this.regionList[i].disabled = true;
            }
          }
          this.formValidate.regionVisible = false;
          this.formValidate.regionValue = '';
        } else if (type == 'landmark'){
          let inputValue = this.formValidate.landmarkValue;
          if (inputValue) {
            this.formValidate.landmarkKeyword.push(inputValue);
          }
          for (let i = 0; i < this.landmarkList.length; i++){
            if (this.landmarkList[i].name == inputValue){
              this.landmarkList[i].disabled = true;
            }
          }
          this.formValidate.landmarkVisible = false;
          this.formValidate.landmarkValue = '';
        } else if(type == 'apartmentClassify'){
          let inputValue = this.formValidate.apartmentClassifyValue;
          for (let i = 0; i < this.formValidate.apartmentClassifyList.length; i++){
            if (this.formValidate.apartmentClassifyList[i].name == inputValue){
              this.$message.error('您输入的名字已存在，不能重复增加！');
              return;
            }
          }
          if (inputValue) {
            this.formValidate.apartmentClassifyList.push({name:inputValue,houseId:this.$route.query.data.id,status:1});
          }
          this.setBatch('新增成功！');
          this.formValidate.apartmentClassifyVisible = false;
          this.formValidate.apartmentClassifyValue = '';
        } else if(type == 'price'){
          let inputValue = this.formValidate.priceValue;
          let priceLeaseValue = this.formValidate.priceLeaseValue;
          if (inputValue && priceLeaseValue) {
            this.formValidate.priceList.push(inputValue+'/周(租期'+priceLeaseValue+'周)');
          }
          this.formValidate.priceVisible = false;
          this.formValidate.priceValue = '';
          this.formValidate.priceLeaseValue = '';
        } else if(type == "tagHouse"){
          let inputValue = this.formValidate.tagHouseValue,tagId = 0;
          for (let i = 0; i < this.tagHouseList.length; i++){
            if (this.tagHouseList[i].name == inputValue){
              this.tagHouseList[i].disabled = true;
              tagId = this.tagHouseList[i].id;
            }
          }
          this.formValidate.tagHouseVisible = false;
          this.formValidate.tagHouseValue = '';
          if (inputValue) {
            this.formValidate.tagHouseKeyword.push({houseId:this.$route.query.data.id,status:1,tagId:tagId,tagName:inputValue});
          }
          // 保存标签
          if (this.formValidate.tagHouseKeyword != ""){
            this.saveTagHouse();
          }
        }
      },
      // 申请房源流水号
      async getHouseApplyNo(data) {
        this.formValidate.no = await this.getHouseApplyNoByNo(data);
      },
      // 房源流水号
      getHouseApplyNoByNo(data) {
        return new Promise((resolve)=>{
          this.$api.houseApplyNo({cityName:data,mode:this.formValidate.mode,apartmentNo:""}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        })
      },
      // 获取时间
      getTime(time) {
        if (time == undefined || time == null || time == "") {
          return null;
        } else {
          const d = new Date(time);
          const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate()) + ' ' + this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds());
          return resDate;
        }
      },
      // 时间是否需要补0
      p(s) {
        return s < 10 ? '0' + s : s
      },
      // 新增学校弹出框
      openSchool(){
        this.formValidate.schoolVisible = true;
        this.schoolForm = { // 公共交通
          id:"",// 公共交通id
          houseId:"",// 房源id
          schoolValue: "", // 学校
          schoolDistance: "", // 到校距离
          schoolWalkTime: "", // 步行到校时间
          schoolTramTime: "", // 电车到校时间
          schoolTransitTime: "", // 公交到校时间
          schoolTrainTime: "", // 火车到校时间
        }
        this.$refs['schoolForm'].resetFields();
      },
      // 编辑公共交通弹出框
      editSchool(data){
        this.schoolForm.id = data.id;
        this.schoolForm.houseId = this.$route.query.data.id;
        this.schoolForm.schoolValue = data.schoolId;
        this.schoolForm.schoolDistance = data.distance;
        this.schoolForm.schoolWalkTime = data.walking;
        this.schoolForm.schoolTramTime = data.tram;
        this.schoolForm.schoolTransitTime = data.bus;
        this.schoolForm.schoolTrainTime = data.train;
        this.formValidate.schoolVisible = true;
      },
      // 提交上传房源优惠
      waySubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {},title = "";
            if (this.schoolForm.id == ""){
              params = {
                schoolId:this.schoolForm.schoolValue,
                houseId:this.$route.query.data.id,
                distance:this.schoolForm.schoolDistance,
                walking:this.schoolForm.schoolWalkTime,
                rule:this.schoolForm.discountRule,
                tram:this.schoolForm.schoolTramTime,
                bus:this.schoolForm.schoolTransitTime,
                train:this.schoolForm.schoolTrainTime,
                status:1
              }
              title = "新增";
            } else {
              params = {
                id:this.schoolForm.id,
                schoolId:this.schoolForm.schoolValue,
                houseId:this.$route.query.data.id,
                distance:this.schoolForm.schoolDistance,
                walking:this.schoolForm.schoolWalkTime,
                rule:this.schoolForm.discountRule,
                tram:this.schoolForm.schoolTramTime,
                bus:this.schoolForm.schoolTransitTime,
                train:this.schoolForm.schoolTrainTime,
                status:1
              }
              title = "编辑";
            }
            this.$api.saveOrUpdateWay({parameter: JSON.stringify(params)}).then(async res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                this.formValidate.schoolVisible = false;
                for (let i = 0; i < this.schoolList.length; i++){
                  if (this.schoolForm.schoolValue == this.schoolList[i].id){
                    this.schoolList[i].disabled = true;
                  }
                }
                //获取房源到校方式
                this.formValidate.schoolKeyword = await this.getWayList(this.$route.query.data.id);
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        });
      },
      // 新增公共交通弹出框
      openTraffic(){
        this.formValidate.trafficVisible = true;
        this.trafficForm = { // 公共交通
          id:"",// 公共交通id
          trafficMode: 1, // 交通方式
          houseId: "", // 房源id
          stationName: "", // 站名
          trafficDistance: "", // 到公共交通距离
          trafficTime: "", // 到公共交通时间
        }
        this.$refs['trafficForm'].resetFields();
      },
      // 编辑公共交通弹出框
      editTraffic(data){
        this.trafficForm.id = data.id;
        this.trafficForm.trafficMode = data.type;
        this.trafficForm.houseId = this.$route.query.data.id;
        this.trafficForm.trafficDistance = data.distance;
        this.trafficForm.trafficTime = data.timeInfo;
        this.trafficForm.stationName = data.name;
        this.formValidate.trafficVisible = true;
      },
      // 提交公共交通
      trafficSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {},title = "";
            if (this.trafficForm.id == ""){
              params = {
                type:this.trafficForm.trafficMode,
                name:this.trafficForm.stationName,
                houseId:this.$route.query.data.id,
                distance:this.trafficForm.trafficDistance,
                timeInfo:this.trafficForm.trafficTime,
                status:1
              }
              title = "新增";
            } else {
              params = {
                id:this.trafficForm.id,
                type:this.trafficForm.trafficMode,
                name:this.trafficForm.stationName,
                houseId:this.$route.query.data.id,
                distance:this.trafficForm.trafficDistance,
                timeInfo:this.trafficForm.trafficTime,
                status:1
              }
              title = "编辑";
            }
            this.$api.saveOrUpdateTransit({parameter: JSON.stringify(params)}).then(async res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                this.formValidate.trafficVisible = false;
                //获取房源到校方式
                this.formValidate.trafficKeyword = await this.getHouseTransitList(this.$route.query.data.id);
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        });
      },
      // 新增优惠政策弹出框
      openDiscount(type){
        if (type == 1){
          this.formValidate.discountVisible = true;
          this.discountForm = { // 优惠政策
            id:"",// 优惠政策id
            type:1,// 标签类型
            discountLabel: "", // 优惠政策标签
            backgroundColor: "", // 标签背景颜色
            wordColor: "", // 标签字体颜色
            discountContent: "", // 优惠政策内容
            discountRule: "", // 优惠政策规则
            startTime: "",// 优惠政策开始时间
            endTime:"",// 优惠政策结束时间
          }
        } else if(type == 2){
          this.formValidate.discountOutVisible = true;
          this.discountForm = { // 优惠政策
            id:"",// 优惠政策id
            type:2,// 标签类型
            discountLabel: "", // 优惠政策标签
            backgroundColor: "", // 标签背景颜色
            wordColor: "", // 标签字体颜色
            discountContent: "", // 优惠政策内容
            discountRule: "", // 优惠政策规则
            startTime: "",// 优惠政策开始时间
            endTime:"",// 优惠政策结束时间
          }
        }
        this.$refs['discountForm'].resetFields();
      },
      // 编辑优惠政策弹出框
      editDiscount(data,type){
        this.discountForm.id = data.id;
        this.discountForm.discountLabel = data.title;
        this.discountForm.type = data.type;
        this.discountForm.backgroundColor = data.color.split("|")[0];
        this.discountForm.wordColor = data.color.split("|")[1];
        this.discountForm.discountContent = data.content;
        this.discountForm.discountRule = data.rule;
        this.discountForm.startTime = data.startTime;
        this.discountForm.endTime = data.endTime;
        if (type == 1){
          this.formValidate.discountVisible = true;
        } else if(type == 2){
          this.formValidate.discountOutVisible = true;
        }
      },
      // 提交上传房源优惠
      discountSubmit(formName){
        if(new Date(this.discountForm.startTime) > new Date(this.discountForm.endTime)){
          this.$message({
            type: 'error',
            message: '优惠开始时间不能大于优惠结束时间！'
          });
          return;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {},title = "";
            if (this.discountForm.id == ""){
              params = {
                title:this.discountForm.discountLabel,
                color:this.discountForm.backgroundColor+'|'+this.discountForm.wordColor,
                content:this.discountForm.discountContent,
                type:this.discountForm.type,
                rule:this.discountForm.discountRule,
                startTime:this.discountForm.startTime == null ||  this.discountForm.startTime == ''? "":this.getTime(this.discountForm.startTime),
                endTime:this.discountForm.endTime == null ||  this.discountForm.endTime == ''? "":this.getTime(this.discountForm.endTime),
                houseId: this.$route.query.data.id,
                status:1
              }
              title = "新增";
            } else {
              params = {
                id:this.discountForm.id,
                title:this.discountForm.discountLabel,
                type:this.discountForm.type,
                color:this.discountForm.backgroundColor+'|'+this.discountForm.wordColor,
                content:this.discountForm.discountContent,
                rule:this.discountForm.discountRule,
                startTime:this.discountForm.startTime == null ||  this.discountForm.startTime == ''? "":this.getTime(this.discountForm.startTime),
                endTime:this.discountForm.endTime == null ||  this.discountForm.endTime == ''? "":this.getTime(this.discountForm.endTime),
                houseId: this.$route.query.data.id,
                status:1
              }
              title = "编辑";
            }
            this.$api.saveOrUpdatePreferential({parameter: JSON.stringify(params)}).then(async res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                this.formValidate.discountVisible = false;
                this.formValidate.discountOutVisible = false;
                this.formValidate.discountKeyword = await this.getPreferentialsList(this.$route.query.data.id);//获取房源优惠标签
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        });
      },
      // 拼接学校
      getSchoolKeyword(){
        let str = "";
        for(let i = 0; i < this.formValidate.schoolKeyword.length; i++){
          for (let j = 0; j < this.schoolList.length; j++){
            if(this.formValidate.schoolKeyword[i].schoolName == this.schoolList[j].name){
              str += this.schoolList[j].name;
              if(this.schoolList[j].address != ''&& this.schoolList[j].address != null && this.schoolList[j].address != undefined){
                str += ","+this.schoolList[j].address;
              }
              if(this.schoolList[j].ename != '' && this.schoolList[j].ename != null && this.schoolList[j].ename!= undefined){
                str += ","+this.schoolList[j].ename;
              }
              if(this.schoolList[j].introduction != '' && this.schoolList[j].introduction!= null && this.schoolList[j].introduction != undefined){
                str += ","+this.schoolList[j].introduction;
              }
              if(this.schoolList[j].alias != '' && this.schoolList[j].alias!= null && this.schoolList[j].alias != undefined){
                str += ","+this.schoolList[j].alias;
              }
              str += "|";
            }
          }
        }
        if (str.substr(str.length-1,1) == "|"){
          str = str.slice(0,-1);
        }
        return str;
      },
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate(async(valid) => {
          if (valid) {
            let params = {},title="新增";
            if (this.$route.query.data == undefined){
              params = {
                title:this.formValidate.title,
                city:this.formValidate.city,
                price:this.formValidate.priceList.toString().replace(/,/g, '|'),
                no: this.formValidate.no,
                hot: this.formValidate.hot,
                mode:this.formValidate.mode,
                photo:this.formValidate.photoList.toString().replace(/,/g, '|'),
                video:this.formValidate.videoList.toString().replace(/,/g, '|'),
                mapImage:this.formValidate.mapList,
                link:this.formValidate.link,
                position:this.formValidate.position,
                constructionTime:this.formValidate.constructionTime,
                floor:this.formValidate.floor,
                introduction:this.formValidate.introduction,
                kitchen:this.formValidate.parkingSpace,
                parking:this.formValidate.parking,
                bathroom:this.formValidate.area,
                measure:this.formValidate.measure,
                remarks:this.formValidate.remarks,
                tenancy:this.formValidate.tenancy,
                regionKeyword:this.formValidate.regionKeyword.toString().replace(/,/g, '|'),
                landmarkKeyword:this.formValidate.landmarkKeyword.toString().replace(/,/g, '|'),
                facilityServices:this.formValidate.facilityServices.toString().replace(/,/g, '|'),
                facilityServicesTop:this.formValidate.facilityServicesTop.toString().replace(/,/g, '|'),
                schoolKeyword:this.getSchoolKeyword(),
                houseInfo:this.getHouseInfo(),
                parentId:this.formValidate.parentId,
                status:1
              }
            } else {
              params = {
                id:this.$route.query.data.id,
                apartmentClassify:this.formValidate.editableTabsValue,
                title:this.formValidate.title,
                city:this.formValidate.city,
                price:this.formValidate.priceList.toString().replace(/,/g, '|'),
                no:this.formValidate.no,
                hot:this.formValidate.hot,
                mode:this.formValidate.mode,
                parentId:this.formValidate.parentId,
                photo:this.formValidate.photoList.toString().replace(/,/g, '|'),
                video:this.formValidate.videoList.toString().replace(/,/g, '|'),
                mapImage:this.formValidate.mapList,
                link:this.formValidate.link,
                position:this.formValidate.position,
                constructionTime:this.formValidate.constructionTime,
                floor:this.formValidate.floor,
                introduction:this.formValidate.introduction,
                kitchen:this.formValidate.parkingSpace,
                parking:this.formValidate.parking,
                bathroom:this.formValidate.area,
                measure:this.formValidate.measure,
                remarks:this.formValidate.remarks,
                tenancy:this.formValidate.tenancy,
                regionKeyword:this.formValidate.regionKeyword.toString().replace(/,/g, '|'),
                landmarkKeyword:this.formValidate.landmarkKeyword.toString().replace(/,/g, '|'),
                facilityServices:this.formValidate.facilityServices.toString().replace(/,/g, '|'),
                facilityServicesTop:this.formValidate.facilityServicesTop.toString().replace(/,/g, '|'),
                schoolKeyword:this.getSchoolKeyword(),
                houseInfo:this.getHouseInfo(),
                status:1
              }
              title = "编辑";
            }
            this.$api.saveOrUpdateHouse({parameter: JSON.stringify(params)}).then(async res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                let data = res.data.data;
                if (this.$route.query.type == 1){
                  if (this.$route.query.data == undefined){
                    this.$route.query.data = res.data.data;
                    this.$forceUpdate();
                  } else {
                    this.$router.push('/HousingManagementFullRent');
                  }
                } else if (this.$route.query.type == 2){
                  this.modeData = data;
                  this.formValidate.parentIdNew = data.id;
                  this.formValidate.title = data.title;
                  this.formValidate.city = data.city;
                  this.formValidate.price = data.price != '' ? data.price.split('|'):[];
                  this.formValidate.mode = data.mode;
                  this.formValidate.no = data.no;
                  this.formValidate.hot = data.hot;
                  this.formValidate.link = data.link;
                  this.formValidate.position = data.position;
                  this.formValidate.floor = data.floor;
                  this.formValidate.introduction = data.introduction;
                  this.formValidate.parkingSpace = data.kitchen;
                  this.formValidate.parking = data.parking;
                  this.formValidate.area = data.bathroom;
                  this.formValidate.measure = data.measure;
                  this.formValidate.constructionTime = data.constructionTime;
                  this.formValidate.remarks = data.remarks;
                  this.formValidate.tenancy = data.tenancy;
                  this.formValidate.parentId = data.parentId;
                  this.formValidate.photoList = data.photo != ''?data.photo.split("|"):[];
                  this.formValidate.videoList = data.video != ''?data.video.split("|"):[];
                  this.formValidate.mapList = data.mapImage != ''?data.mapImage:'';
                  //获取房源到校方式
                  this.formValidate.schoolKeyword = await this.getWayList(data.id);
                  for (let i = 0; i < this.schoolList.length; i++){
                    for(let j = 0; j < this.formValidate.schoolKeyword.length; j++){
                      if (this.formValidate.schoolKeyword[j].schoolId == this.schoolList[i].id){
                        this.schoolList[i].disabled = true;
                      }
                    }
                  }
                  //获取房源公共交通距离和时间
                  this.formValidate.trafficKeyword = await this.getHouseTransitList(data.id);
                  this.formValidate.regionKeyword = data.regionKeyword != ''?data.regionKeyword.split("|"):[];
                  if (data.regionKeyword != ''){
                    let region =  data.regionKeyword.split("|");
                    for (let i = 0; i < this.regionList.length; i++){
                      for (let j = 0; j < region.length; j++){
                        if (this.regionList[i].name == region[j]){
                          this.regionList[i].disabled = true;
                        }
                      }
                    }
                  }
                  this.formValidate.landmarkKeyword = data.landmarkKeyword != ''?data.landmarkKeyword.split("|"):[];
                  if (data.landmarkKeyword != ''){
                    let landmark =  data.landmarkKeyword.split("|");
                    for (let i = 0; i < this.landmarkList.length; i++){
                      for (let j = 0; j < landmark.length; j++){
                        if (this.landmarkList[i].name == landmark[j]){
                          this.landmarkList[i].disabled = true;
                        }
                      }
                    }
                  }
                  let houseInfo = data.houseInfo.split("|");
                  this.formValidate.measure = houseInfo[0];
                  this.formValidate.area = houseInfo[1];
                  this.formValidate.furniture = houseInfo[2];
                  this.formValidate.parkingSpace = houseInfo[3];
                  this.formValidate.parkingSpaceA = houseInfo[4];
                  //this.formValidate.parking = houseInfo[3];
                  this.formValidate.facilityServices = data.facilityServices != '' ? data.facilityServices.split("|"):[];
                  this.formValidate.facilityServicesTop = data.facilityServicesTop !=''? data.facilityServicesTop.split("|"):[];
                  let getFacilityServices = data.facilityServices != '' ? data.facilityServices.split("|"):[];
                  let getFacilityServicesTop = data.facilityServicesTop != ''?data.facilityServicesTop.split("|"):[];
                  for (let i = 0; i < this.formValidate.projectList.length; i++){
                    for (let j = 0; j < getFacilityServices.length; j++){
                      if (this.formValidate.projectList[i].name == getFacilityServices[j]){
                        this.formValidate.projectList[i].value = true;
                      }
                    }
                    for (let m = 0; m < getFacilityServicesTop.length; m++){
                      if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
                        this.formValidate.projectList[i].top = true;
                      }
                    }
                  }
                  this.formValidate.isMode = true;
                  await this.getApartmentClassify();
                  this.getList();
                } else if (this.$route.query.type == 3){
                  if (this.$route.query.data == undefined){
                    this.$route.query.data = res.data.data;
                    this.$forceUpdate();
                  } else {
                    this.$router.push('/HousingManagementShortLease');
                  }
                }
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        })
      },
      //获取费用明细数据
      getCost(houseId){
        this.$api.getCostHouseByHouseId({houseId:houseId}).then(async res => {
          if (res.data.status == 200) {
            this.table.costTableData = res.data.data;
            this.checkIdsCost = [];
            if (this.table.costTableData != ''){
              this.$nextTick(() => {
                this.$refs.costTableData.clearSelection();
              });
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 新建费用
      addCost(){
        this.typeMess = 2;
        this.addOrEdit = 1;
        this.houseIdAOE = this.$route.query.data.id;
        this.houseVisible = true;
        this.houseTitle = "新增费用信息";
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      // 删除费用
      delCost(){
        for (let i = 0; i < this.table.costTableData.length; i++){
          for (let j = 0; j < this.checkIdsCost.length; j++){
            if (this.table.costTableData[i].id == this.checkIdsCost[j]){
              this.table.costTableData[i].status = 0;
            }
          }
        }
        this.setCostBatch('批量删除成功！');
      },
      // 编辑/删除
      editCost(type,row){
        if (type == "edit") {  // 编辑操作
          this.typeMess = 2;
          this.addOrEdit = 2;
          this.houseIdAOE = this.$route.query.data.id;
          this.houseVisible = true;
          this.houseTitle = "编辑费用信息";
          this.childData = row;
          let that = this;
          that.$nextTick(() => {
            $(".dialog-content").height(window.innerHeight - 150);
          })
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.costTableData.length; i++){
            if (row.id == this.table.costTableData[i].id){
              this.table.costTableData[i].status = 0;
            }
          }
          this.setCostBatch('删除成功！');
        }
      },
      // 获取床垫id
      getMattressId(id){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"},{"field":"house_id", "fun":"eq", "value": id}];
          this.$api.findMattress({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 保存标签
      async saveTagHouse(){
        this.$api.saveOrUpdateTagHouseBatch({parameter: JSON.stringify(this.formValidate.tagHouseKeyword)}).then(async res => {
          if (res.data.status == 200) {
            //获取房源标签
            this.formValidate.tagHouseKeyword = await this.getTagHouseAllList(this.$route.query.data.id);
            for (let i = 0; i < this.tagHouseList.length; i++){
              for(let j = 0; j < this.formValidate.tagHouseKeyword.length; j++){
                if (this.formValidate.tagHouseKeyword[j].tagId == this.tagHouseList[i].name){
                  this.tagHouseList[i].disabled = true;
                }
              }
            }
          }
        });
      },
      // 获取是否选中
      handleChange(event,item,type){
        if (event){
          if (type != undefined){
            this.formValidate.facilityServicesTop.push(item);
          } else {
            this.formValidate.facilityServices.push(item);
          }
        } else {
          if (type != undefined){
            this.formValidate.facilityServicesTop = this.formValidate.facilityServicesTop.filter(t => t !== item);
          } else {
            this.formValidate.facilityServices = this.formValidate.facilityServices.filter(t => t !== item);
          }
        }
      },
      // 获取房屋信息
      getHouseInfo(){
        let houseInfo = '';
        houseInfo += (this.formValidate.measure == undefined ? '' : this.formValidate.measure)+'|';
        houseInfo += (this.formValidate.area == undefined ? '' : this.formValidate.area)+'|';
        houseInfo += (this.formValidate.furniture == undefined ? '' : this.formValidate.furniture)+'|';
        houseInfo += (this.formValidate.parkingSpace == undefined ? '' : this.formValidate.parkingSpace)+'|';
        houseInfo += (this.formValidate.parkingSpaceA == undefined ? '': this.formValidate.parkingSpaceA)+'|';
        //houseInfo += this.formValidate.parking == undefined ? '' : this.formValidate.parking+'|';
        // if (houseInfo.substr(houseInfo.length-1,1) == "|"){
        //   houseInfo = houseInfo.slice(0,-1);
        // }
        return houseInfo;
      },
      //返回上一页
      onCancel(){
        if (this.$route.query.type == 1){
          this.$router.push('/HousingManagementFullRent');
        } else if (this.$route.query.type == 2){
          this.$router.push('/HousingManagementSchool');
        } else if (this.$route.query.type == 3){
          this.$router.push('/HousingManagementShortLease');
        }
      },
      //房型新增
      addTab(){
        this.formValidate.apartmentClassifyVisible = true;
        this.fangAdd = true;
        this.formValidateHouse = {
          id:"",// 户型分类id
          name: "", // 户型名称
          introduction: "", // 户型简介
        }
        if (this.$refs['formValidateHouse'] != undefined){
          this.$refs['formValidateHouse'].resetFields();
        }
        /*this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });*/
      },
      // 编辑/删除
      editTab(type,row){
        if (type == "edit") {  // 编辑操作
          this.formValidateHouse = {
            id:row.id,// 户型分类id
            name: row.name, // 户型名称
            introduction: row.introduction, // 户型简介
          }
          this.fangAdd = false;
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.formValidate.apartmentClassifyList.length; i++){
            if (row.id == this.formValidate.apartmentClassifyList[i].id){
              this.formValidate.apartmentClassifyList[i].status = 0;
            }
          }
          this.setBatch('删除成功！');
        }
      },
      //房型保存
      saveTab(formName){
        let inputValue = this.formValidateHouse.name;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.fangAdd){
              if (inputValue) {
                this.formValidate.apartmentClassifyList.push({id:0,name:inputValue,introduction:this.formValidateHouse.introduction,houseId:this.$route.query.data.id,status:1});
              }
              this.setBatch('新增成功！');
            } else {
              for (let i = 0; i < this.formValidate.apartmentClassifyList.length; i++){
                if (this.formValidate.apartmentClassifyList[i].id == this.formValidateHouse.id){
                  this.formValidate.apartmentClassifyList[i].name = this.formValidateHouse.name;
                  this.formValidate.apartmentClassifyList[i].introduction = this.formValidateHouse.introduction;
                }
              }
              this.setBatch('编辑成功！');
            }
          }
        })
      },
      //房型删除
      removeTab(targetName) {
        this.$confirm('是否确定删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for(let i = 0 ; i < this.formValidate.apartmentClassifyList.length; i++){
            if (targetName == this.formValidate.apartmentClassifyList[i].name){
              this.formValidate.apartmentClassifyList[i].status = 0;
            }
          }
          this.setBatch('删除成功！');
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //切换选中
      handleClick(tab){
        this.formValidate.editableTabsValue = this.formValidate.apartmentClassifyList[tab.index].name;
        this.getList();
      },
      //批量添加修改列表
      setBatchHouse(title,ids){
        this.$api.houseDeleteBatch({ ids:ids.toString() }).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.checkIds = [];
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      //批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdateApartmentClassifyBatch({ parameter: JSON.stringify(this.formValidate.apartmentClassifyList)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getApartmentClassify();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      //批量添加修改列表
      setCostBatch(title){
        this.$api.saveOrUpdateCostHouseBatch({ parameter: JSON.stringify(this.table.costTableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getCost(this.$route.query.data.id);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      //获取房型
      async getApartmentClassify(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"houseId",
          "fun":"eq",
          "value": this.$route.query.data.id
        }];
        await this.$api.findApartmentClassify({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
          if (res.data.status == 200) {
            this.formValidate.apartmentClassifyList = res.data.data.records;
            this.formValidate.tabIndex = Number(res.data.data.total);
            if (this.formValidate.apartmentClassifyList != ''){
              this.formValidate.editableTabsValue = this.formValidate.apartmentClassifyList[0].name;
            }
            this.formValidateHouse = {
              id:"",// 户型分类id
              name: "", // 户型名称
              introduction: "", // 户型简介
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      //切换选择
      handleSelectionCostChange(val) {
        this.checkIdsCost = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIdsCost.push(val[i].id);
          }
        }
      },
      //切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      //编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.childData = row;
          this.isEdit = 2;
          this.title = "编辑户型";
          this.outerVisible = true;
          let that = this;
          that.$nextTick(() => {
            $(".dialog-content").height(window.innerHeight - 150);
          })
        } else if (type == "remove") { // 删除操作
          this.$api.houseDelete({houseId:row.id}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: "删除成功！",
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        } else if (type == "copy") { // 复制操作
          this.$api.houseCopy({houseId:row.id}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: "复制成功！",
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      //新增房源
      addSchool(){
        if(this.formValidate.parentIdNew != ''){
          this.childData = this.modeData;
          this.isEdit = 1; // 新增房源
        } else {
          this.childData = {};
          this.isEdit = 1; // 新增房源
        }
        this.title = "新增户型";
        this.outerVisible = true;
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      //删除房源
      delSchool(){
        this.setBatchHouse('批量删除成功！',this.checkIds);
      },
      //批量修改
      editSchoolAll(){
        /*if(this.checkIds == ""){
          this.$message.error('请先选择需要批量修改的数据！');
          return;
        }
        this.allList = [];
        this.typeMess = 3;
        this.addOrEdit = 1;
        this.houseIdAOE = this.$route.query.data.id;
        this.houseVisible = true;
        this.houseTitle = "批量修改户型";
        this.tableData = !this.tableData;
        this.allList = this.checkIds;
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })*/
        this.tableData = !this.tableData;
        this.editSaveBtn = false;
        for (let i = 0; i < this.table.tableData.length; i++){
          this.$set(this.table.tableData[i],"showEdit",true);
        }
      },
      // 保存
      saveSchoolAll(){
        let array  = [];
        for (let i = 0; i < this.table.tableData.length; i++){
          let obj = {
            id:this.table.tableData[i].priceId,
            price:this.table.tableData[i].price,
            houseId:this.table.tableData[i].houseId,
            start:this.table.tableData[i].start == null ||  this.table.tableData[i].start == ''? "":this.getDateA(this.table.tableData[i].start),
            finis:this.table.tableData[i].finis == null ||  this.table.tableData[i].finis == ''? "":this.getDateA(this.table.tableData[i].finis),
            term:this.table.tableData[i].term,
            status:1,
          };
          array.push(obj);
        }
        this.$api.saveOrUpdatePriceBatch({parameter: JSON.stringify(array)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              type: 'success',
              message: '保存成功！'
            });
            this.getList();
            this.tableData = !this.tableData;
            this.editSaveBtn = true;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 获取时间
      getDateA(time) {
        if (time == undefined || time == null || time == "") {
          return null;
        } else {
          const d = new Date(time);
          const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate());
          return resDate;
        }
      },
      // 改变热门
      changeHot(id,data,type){
        let params = {};
        if (type == 'soldout'){
          let soldout = id == true ? 1 : 0;
          params = { id: data.id,soldout:soldout };
        } else {
          let grounding = id == true ? 1 : 0;
          params = { id: data.id,grounding:grounding };
        }
        this.$api.saveOrUpdateHouse({parameter: JSON.stringify(params)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      //切换房型
      async getMode(e){
        if (e == "学生公寓"){
          if (this.$route.query.data != undefined){
            await this.getApartmentClassify();
            this.getList();
          }
        }
      },
      //获取表格数据
      getList(){
        this.$api.getChildrenOfApartment({
          apartmentClassify:this.formValidate.editableTabsValue,
          houseId:this.$route.query.data.id
        }).then(async res => {
          if (res.data.status == 200) {
            let array = res.data.data;
            this.paging.total = Number(res.data.data.length);
            for (let i = 0; i < array.length; i++){
              if (array[i].priceList != undefined && array[i].priceList != null && array[i].priceList != ""){
                for (let j = 0; j < array[i].priceList.length; j++){
                  if (j == 0){
                    array[i].priceId = array[i].priceList[0].id;
                    array[i].showEdit = array[i].priceList[0].showEdit;
                    array[i].houseId = array[i].priceList[0].houseId;
                    array[i].start = array[i].priceList[0].start;
                    array[i].finis = array[i].priceList[0].finis;
                    array[i].price = array[i].priceList[0].price;
                    array[i].term = array[i].priceList[0].term;
                  } else {
                    let cc = {
                      priceId:array[i].priceList[j].id,
                      showEdit:array[i].priceList[j].showEdit,
                      houseId:array[i].priceList[j].houseId,
                      start:array[i].priceList[j].start,
                      finis:array[i].priceList[j].finis,
                      price:array[i].priceList[j].price,
                      term:array[i].priceList[j].term,
                    };
                    array.splice(i+1,0,cc);
                  }
                }
              }
            }
            this.table.tableData = array;
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 合并单元格 - 默认接受四个值 { 当前行的值, 当前列的值, 行的下标, 列的下标 }
      arraySpanMethod({row,column,rowIndex,columnIndex }){
        if (columnIndex != 5 && columnIndex != 6 && columnIndex != 7 && columnIndex != 8){
          if (row.priceList != undefined) {
            if (row.priceList.length > 0){
              return [row.priceList.length,1];
            }
          } else {
            return [0,0];
          }
        }
      },
      // 获取户型价格数据
      getPriceList(houseId){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"},{"field":"house_id","fun":"like","value": houseId}];
          this.$api.findPrice({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].showEdit = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取城市数据
      getCityList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findCity({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取学校数据
      getSchoolList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findSchool({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取区域数据
      getRegionList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findRegion({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取地标数据
      getLandmarkList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findLandmark({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取服务设施数据
      getFacilitiesList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findFacilities({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              let projectList = res.data.data.records;
              for (let i = 0; i < projectList.length; i++){
                projectList[i].value = false;
                projectList[i].top = false;
              }
              resolve(projectList);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取标签数据
      getTagHouseList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findTag({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 新建设施服务数据
      addFacilities(){
        if (this.formValidate.facilities == ""){
          this.$message({
            type: 'error',
            message: '请输入自定义设施名称！'
          });
          return;
        }
        let params = {
          name:this.formValidate.facilities,
          type:this.formValidate.classification,
          status:1
        }
        this.$api.saveOrUpdateFacilities({parameter: JSON.stringify(params)}).then(async res => {
          if (res.data.status == 200) {
            this.$message({
              type: 'success',
              message: '新增成功！'
            });
            // 获取服务设施数据
            this.formValidate.projectList = await this.getFacilitiesList();
            if (this.$route.query.data != undefined){
              this.formValidate.facilityServices = this.$route.query.data.facilityServices != '' ? this.$route.query.data.facilityServices.split("|"):[];
              this.formValidate.facilityServicesTop = this.$route.query.data.facilityServicesTop !=''? this.$route.query.data.facilityServicesTop.split("|"):[];
              let getFacilityServices = this.$route.query.data.facilityServices != '' ? this.$route.query.data.facilityServices.split("|"):[];
              let getFacilityServicesTop = this.$route.query.data.facilityServicesTop != ''?this.$route.query.data.facilityServicesTop.split("|"):[];
              for (let i = 0; i < this.formValidate.projectList.length; i++){
                for (let j = 0; j < getFacilityServices.length; j++){
                  if (this.formValidate.projectList[i].name == getFacilityServices[j]){
                    this.formValidate.projectList[i].value = true;
                  }
                }
                for (let m = 0; m < getFacilityServicesTop.length; m++){
                  if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
                    this.formValidate.projectList[i].top = true;
                  }
                }
              }
            } else {
              let getFacilityServices = this.formValidate.facilityServices;
              let getFacilityServicesTop = this.formValidate.facilityServicesTop;
              for (let i = 0; i < this.formValidate.projectList.length; i++){
                for (let j = 0; j < getFacilityServices.length; j++){
                  if (this.formValidate.projectList[i].name == getFacilityServices[j]){
                    this.formValidate.projectList[i].value = true;
                  }
                }
                for (let m = 0; m < getFacilityServicesTop.length; m++){
                  if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
                    this.formValidate.projectList[i].top = true;
                  }
                }
              }
            }
            let that = this;
            that.$nextTick(() => {
              that.formValidate.facilityServices.push(that.formValidate.facilities);
              that.formValidate.projectList[that.formValidate.projectList.length - 1].value = true;
              that.formValidate.projectList[that.formValidate.projectList.length - 1].top = false;
              // 清空输入数据
              that.formValidate.facilities = "";
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 更新照片位置
      handleListPictureChange(event){
        this.formValidate.photoList = event;
      },
      // 更新视频位置
      handleListVideoChange(event){
        this.formValidate.videoList = event;
      },
      // 获取房源优惠标签数据
      getPreferentialsList(houseId){
        return new Promise((resolve, reject) => {
          let parameter = [
            {
              "field":"status",
              "fun":"ne",
              "value": "0"
            },
            {
              "field":"houseId",
              "fun":"like",
              "value": houseId
            }];
          this.$api.findPreferential({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取房源到校方式
      getWayList(houseId){
        return new Promise((resolve, reject) => {
          this.$api.getHouseWay({houseId: houseId}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取房源公共交通距离和时间
      getHouseTransitList(houseId){
        return new Promise((resolve, reject) => {
          this.$api.getHouseTransit({houseId: houseId}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取房源标签数据
      getTagHouseAllList(houseId){
        return new Promise((resolve, reject) => {
          this.$api.getTagHouseByHouseId({houseId:houseId}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 新增床垫信息
      addParkingInput(){
        this.typeMess = 4;
        this.addOrEdit = 1;
        this.houseIdAOE = this.$route.query.data.id;
        this.houseVisible = true;
        this.houseTitle = "新增床垫信息";
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      // 删除床垫信息
      delParkingInput(index){
        this.formValidate.mattressList[index].status = 0;
        this.$api.saveOrUpdateMattressBatch({ parameter: JSON.stringify(this.formValidate.mattressList)}).then(async res => {
          if (res.data.status == 200) {
            //获取床垫信息
            this.formValidate.mattressList = await this.getMattressId(this.$route.query.data.id);
          }
        })
      },
      //获取房屋信息数据
      getHouseInfoNew(houseId){
        return new Promise((resolve, reject) => {
          this.$api.getCustomHouseByHouseId({houseId:houseId}).then(async res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 新增房屋信息
      addHousingInput(){
        this.typeMess = 1;
        this.addOrEdit = 1;
        this.houseIdAOE = this.$route.query.data.id;
        this.houseVisible = true;
        this.houseTitle = "新增房屋信息";
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      // 删除房屋信息
      delHousingInput(index){
        this.table.houseTableData[index].status = 0;
        this.$api.saveOrUpdateCustomHouseBatch({ parameter: JSON.stringify(this.table.houseTableData)}).then(async res => {
          if (res.data.status == 200) {
            //获取房屋信息
            this.table.houseTableData = await this.getHouseInfoNew(this.$route.query.data.id);
          }
        })
      },
    },
    async mounted(){
      window.onresize = function () {
        $(".dialog-content").height(window.innerHeight - 150);
      }
      try {
        // 获取城市列表
        this.cityList = await this.getCityList();
        // 获取学校列表
        this.schoolList = await this.getSchoolList();
        // 获取区域列表
        this.regionList = await this.getRegionList();
        // 获取地标列表
        this.landmarkList = await this.getLandmarkList();
        // 获取服务设施数据
        this.formValidate.projectList = await this.getFacilitiesList();
        // 获取标签数据
        this.tagHouseList = await this.getTagHouseList();
      } catch (err) {
        console.log(err)
      }
      if (this.$route.query.type == 1){
        this.formValidate.mode = "整租";
      } else if (this.$route.query.type == 2){
        this.formValidate.mode = "学生公寓";
      } else if (this.$route.query.type == 3){
        this.formValidate.mode = "短租";
      }
      // 编辑情况
      if (this.$route.query.data != undefined){
        this.modeData = this.$route.query.data;
        try {
          //获取房源优惠标签
          this.formValidate.discountKeyword = await this.getPreferentialsList(this.$route.query.data.id);
          //获取房源到校方式
          this.formValidate.schoolKeyword = await this.getWayList(this.$route.query.data.id);
          for (let i = 0; i < this.schoolList.length; i++){
            for(let j = 0; j < this.formValidate.schoolKeyword.length; j++){
              if (this.formValidate.schoolKeyword[j].schoolId == this.schoolList[i].id){
                this.schoolList[i].disabled = true;
              }
            }
          }
          //获取房源到校方式
          this.formValidate.trafficKeyword = await this.getHouseTransitList(this.$route.query.data.id);
          //获取房源标签
          this.formValidate.tagHouseKeyword = await this.getTagHouseAllList(this.$route.query.data.id);
          for (let i = 0; i < this.tagHouseList.length; i++){
            for(let j = 0; j < this.formValidate.tagHouseKeyword.length; j++){
              if (this.formValidate.tagHouseKeyword[j].tagId == this.tagHouseList[i].id){
                this.tagHouseList[i].disabled = true;
              }
            }
          }
          if(this.formValidate.mode =='学生公寓'){
            //获取费用明细数据
            this.getCost(this.$route.query.data.id);
          }
          //获取房屋信息数据
          this.table.houseTableData = await this.getHouseInfoNew(this.$route.query.data.id);
          //获取床垫信息
          this.formValidate.mattressList = await this.getMattressId(this.$route.query.data.id);
        } catch (err) {
          console.log(err)
        }
        this.formValidate.isMode = true;
        this.formValidate.title = this.$route.query.data.title;
        this.formValidate.city = this.$route.query.data.city;
        this.formValidate.priceList = this.$route.query.data.price != ''?this.$route.query.data.price.split("|"):[];
        this.formValidate.mode = this.$route.query.data.mode;
        this.formValidate.no = this.$route.query.data.no;
        this.formValidate.hot = this.$route.query.data.hot;
        this.formValidate.link = this.$route.query.data.link;
        this.formValidate.position = this.$route.query.data.position;
        this.formValidate.floor = this.$route.query.data.floor;
        this.formValidate.introduction = this.$route.query.data.introduction;
        this.formValidate.tenancy = this.$route.query.data.tenancy;
        this.formValidate.parkingSpace = this.$route.query.data.parkingSpace;
        this.formValidate.parking = this.$route.query.data.parking;
        this.formValidate.area = this.$route.query.data.bathroom;
        this.formValidate.measure = this.$route.query.data.measure;
        this.formValidate.constructionTime = this.$route.query.data.constructionTime;
        this.formValidate.remarks = this.$route.query.data.remarks;
        this.formValidate.parentId = this.$route.query.data.parentId;
        this.formValidate.photoList = this.$route.query.data.photo != '' && this.$route.query.data.photo != null?this.$route.query.data.photo.split("|"):[];
        this.formValidate.videoList = this.$route.query.data.video != '' && this.$route.query.data.video != null?this.$route.query.data.video.split("|"):[];
        this.formValidate.mapList = this.$route.query.data.mapImage != '' && this.$route.query.data.mapImage != null?this.$route.query.data.mapImage:"";
        this.formValidate.regionKeyword = this.$route.query.data.regionKeyword != ''?this.$route.query.data.regionKeyword.split("|"):[];
        if (this.$route.query.data.regionKeyword != ''){
          let region =  this.$route.query.data.regionKeyword.split("|");
          for (let i = 0; i < this.regionList.length; i++){
            for (let j = 0; j < region.length; j++){
              if (this.regionList[i].name == region[j]){
                this.regionList[i].disabled = true;
              }
            }
          }
        }
        this.formValidate.landmarkKeyword = this.$route.query.data.landmarkKeyword != ''?this.$route.query.data.landmarkKeyword.split("|"):[];
        if (this.$route.query.data.landmarkKeyword != ''){
          let landmark =  this.$route.query.data.landmarkKeyword.split("|");
          for (let i = 0; i < this.landmarkList.length; i++){
            for (let j = 0; j < landmark.length; j++){
              if (this.landmarkList[i].name == landmark[j]){
                this.landmarkList[i].disabled = true;
              }
            }
          }
        }
        let houseInfo = this.$route.query.data.houseInfo.split("|");
        this.formValidate.measure = houseInfo[0];
        this.formValidate.area = houseInfo[1];
        this.formValidate.furniture = houseInfo[2];
        this.formValidate.parkingSpace = houseInfo[3];
        this.formValidate.parkingSpaceA = houseInfo[4];
        //this.formValidate.parking = houseInfo[3];
        this.formValidate.facilityServices = this.$route.query.data.facilityServices != '' ? this.$route.query.data.facilityServices.split("|"):[];
        this.formValidate.facilityServicesTop = this.$route.query.data.facilityServicesTop !=''? this.$route.query.data.facilityServicesTop.split("|"):[];
        let getFacilityServices = this.$route.query.data.facilityServices != '' ? this.$route.query.data.facilityServices.split("|"):[];
        let getFacilityServicesTop = this.$route.query.data.facilityServicesTop != ''?this.$route.query.data.facilityServicesTop.split("|"):[];
        for (let i = 0; i < this.formValidate.projectList.length; i++){
          for (let j = 0; j < getFacilityServices.length; j++){
            if (this.formValidate.projectList[i].name == getFacilityServices[j]){
              this.formValidate.projectList[i].value = true;
            }
          }
          for (let m = 0; m < getFacilityServicesTop.length; m++){
            if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
              this.formValidate.projectList[i].top = true;
            }
          }
        }
        if (this.formValidate.mode == "学生公寓" && this.$route.query.data != undefined){
          await this.getApartmentClassify();
          this.getList();
        }
      } else {
        this.formValidate.isMode = false;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/HousingManagementOperation.vue